module.exports = __webpack_public_path__ + "static/media/bold.6b8a0450.svg";